module.exports = __webpack_public_path__ + "static/media/about_03.9358f67f.png";